import { render, staticRenderFns } from "./MenuModular.vue?vue&type=template&id=76bfb8da&scoped=true&"
import script from "./MenuModular.vue?vue&type=script&lang=js&"
export * from "./MenuModular.vue?vue&type=script&lang=js&"
import style0 from "./MenuModular.vue?vue&type=style&index=0&id=76bfb8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfb8da",
  null
  
)

export default component.exports